'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module4Act = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, profile: state.profile.data, app: state.moduleData.data.module4.act1 };
}, (0, _extends3.default)({}, moduleActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4Act, _Component);

  function Module4Act() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4Act);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4Act.__proto__ || (0, _getPrototypeOf2.default)(Module4Act)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Planning ahead',
      moduleId: 4,
      appId: 1,
      isCompleted: false,
      difficult1: _this.props.app.difficult1 || '',
      strategy1: _this.props.app.strategy1 || '',
      difficult2: _this.props.app.difficult2 || '',
      strategy2: _this.props.app.strategy2 || '',
      difficult3: _this.props.app.difficult3 || '',
      strategy3: _this.props.app.strategy3 || ''
    }, _this.handleComplete = function () {
      var obj = _this.state;
      obj.isCompleted = true;
      _this.setState(obj);

      _this.props.updateModuleAct(_this.props.user.userId, _this.state.moduleId, _this.state.appId, obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * General function used to change state of object
   */


  (0, _createClass3.default)(Module4Act, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 3'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'p',
                null,
                'It might also be useful to write down any difficult situations you think you might face in the future. Can you think of any?'
              ),
              _react2.default.createElement(
                'h5',
                null,
                'How do you think you will manage them?'
              ),
              _react2.default.createElement(
                ReactBootstrap.Table,
                { bordered: true, striped: true },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      'Difficult situation or environment'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Strategies to manage the situation'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'Difficult situation or environment',
                        value: this.state.difficult1,
                        onChange: this.handleChange.bind(this, 'difficult1') })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'Strategies to manage the situation',
                        value: this.state.strategy1,
                        onChange: this.handleChange.bind(this, 'strategy1') })
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'Difficult situation or environment',
                        value: this.state.difficult2,
                        onChange: this.handleChange.bind(this, 'difficult2') })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'Strategies to manage the situation',
                        value: this.state.strategy2,
                        onChange: this.handleChange.bind(this, 'strategy2') })
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'Difficult situation or environment',
                        value: this.state.difficult3,
                        onChange: this.handleChange.bind(this, 'difficult3') })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'Strategies to manage the situation',
                        value: this.state.strategy3,
                        onChange: this.handleChange.bind(this, 'strategy3') })
                    )
                  )
                )
              ),
              _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
            )
          )
        )
      );
    }
  }]);
  return Module4Act;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModuleAct: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module4Act;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/Activities/Act1.js
// module id = 1204
// module chunks = 0